import React from 'react'
import { connect } from 'react-redux'
import dispatchers from 'reduxModules/subscribeDialogCTA/dispatchers'
import { promotionSelector } from 'reduxModules/app/selectors'
import './styles.css'

export function SubscribeDialogCTA({ dispatchSubscriptionPage, promotion, children }) {
  return (
    <button type="button" onClick={() => dispatchSubscriptionPage(promotion)}>
      {children}
    </button>
  )
}

export default connect(promotionSelector, dispatchers)(SubscribeDialogCTA)
